import React from 'react';
import PropTypes from 'prop-types';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function AttachmentsButton({ content, onClick, disabled }) {
  return (
    <CPButton
      title="Додані файли"
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faPaperclip}
    />
  );
}

AttachmentsButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

AttachmentsButton.defaultProps = {
  onClick: () => null,
  content: 'Файли',
  disabled: false,
};

export default AttachmentsButton;
